import { FC } from 'react';
import {
  getCurrentProfile,
  getIpis,
  getIpns,
  getIsnis,
  getProfileIdsLoadingState,
  getProfileLoadingStateSelector,
  getUpdateLink,
} from 'app/store/Profile/selectors';
import { getCountries } from 'app/store/Countries/selectors';
import { fetchCountriesEffect } from 'app/store/Countries/effects';
import { useAppDispatch, useAppSelector } from 'app/store';
import { convertToProfileFormData } from 'app/views/Profile/utils';
import { ContentContainer } from 'app/components/Core/ChakraContentContainer';
import { ContainerProps } from '@chakra-ui/react';
import { ContentContainerType, LoadingState } from 'types/enums';
import { useFetchValidationSchema, useResource } from 'app/utils/hooks';
import { ProfileForm } from '../ProfileForm';
import { toCountryOptions } from '../ProfilePersonalSection/utils';
import { ProfileFormLoader } from '../ProfileFormLoader';

export const BasicProfile: FC<ContainerProps> = (containerProps) => {
  const currentProfile = useAppSelector(getCurrentProfile);
  const dispatch = useAppDispatch();
  const ipis = useAppSelector(getIpis);
  const ipns = useAppSelector(getIpns);
  const isnis = useAppSelector(getIsnis);
  const profileUpdateLink = useAppSelector(getUpdateLink);

  const profileIdsLoadingState = useAppSelector(getProfileIdsLoadingState);
  const profileLoadingState = useAppSelector(getProfileLoadingStateSelector);
  const [countries] = useResource(fetchCountriesEffect, getCountries);
  const countryOptions = toCountryOptions(countries);

  const {
    validationSchema,
    validationSchemaFetched,
  } = useFetchValidationSchema({ link: profileUpdateLink });

  const loaded =
    profileLoadingState === LoadingState.FETCHED &&
    countries &&
    profileIdsLoadingState === LoadingState.FETCHED &&
    validationSchemaFetched;

  return (
    <ContentContainer
      type={ContentContainerType.FORM}
      pt={4}
      {...containerProps}
    >
      {loaded && currentProfile ? (
        <ProfileForm
          defaultValues={convertToProfileFormData(
            currentProfile,
            countryOptions,
            ipis,
            ipns,
            isnis
          )}
          dispatch={dispatch}
          countries={countryOptions}
          validationSchema={validationSchema}
        />
      ) : (
        <ProfileFormLoader />
      )}
    </ContentContainer>
  );
};
